var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply-area"},[_c('apply-header',{attrs:{"title":"その他申請"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"30px","fontSize":"72px","fontWeight":"600"}},[_vm._v("工事中")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3f187de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/applyType/OtherApplications.vue
// module id = null
// module chunks = 